(function () {
  /* Shopify's own money format, so totals always match the prices Liquid rendered. */
  function fmt(cents, format) {
    var ph = /\{\{\s*(\w+)\s*\}\}/;
    function dp(n, precision, thousands, decimal) {
      if (isNaN(n) || n === null) return '0';
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return head + (parts[1] ? decimal + parts[1] : '');
    }
    var m = (format || '').match(ph);
    if (!m) return '$' + (cents / 100).toFixed(2);
    var v;
    switch (m[1]) {
      case 'amount_no_decimals': v = dp(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = dp(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = dp(cents, 0, '.', ','); break;
      default: v = dp(cents, 2, ',', '.');
    }
    return format.replace(ph, v);
  }

  function fireworks(host, burstSVG) {
    if (!host || !burstSVG) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    for (var i = 0; i < 9; i++) {
      (function (n) {
        setTimeout(function () {
          var b = document.createElement('span');
          b.className = 'giftb__fw-burst';
          b.style.left = (6 + Math.random() * 88) + '%';
          b.style.top = (8 + Math.random() * 72) + '%';
          b.style.setProperty('--fw-size', Math.round(32 + Math.random() * 44) + 'px');
          b.style.setProperty('--fw-spin', Math.round(Math.random() * 90) + 'deg');
          b.appendChild(burstSVG.cloneNode(true));
          host.appendChild(b);
          setTimeout(function () { if (b.parentNode) b.parentNode.removeChild(b); }, 1500);
        }, n * 300);
      })(i);
    }
  }

  function init() {
    var root = document.querySelector('[data-gift-root]');
    if (!root) return;

    var MONEY   = root.getAttribute('data-money') || '${{amount}}';
    var MAX     = parseInt(root.getAttribute('data-maxlen'), 10) || 160;
    var CODE    = (root.getAttribute('data-discount') || '').trim();

    var rows    = [].slice.call(root.querySelectorAll('[data-item]'));
    var linesEl = root.querySelector('#gift-lines');
    var noneEl  = root.querySelector('#gift-none');
    var totalEl = root.querySelector('#gift-total');
    var addBtn  = root.querySelector('#gift-add');
    var statusEl= root.querySelector('#gift-status');

    var toEl    = root.querySelector('#gift-to');
    var fromEl  = root.querySelector('#gift-from');
    var msgEl   = root.querySelector('#gift-msg');
    var countEl = root.querySelector('#gift-count');
    var maxEl   = root.querySelector('#gift-max');

    var pjEl    = root.querySelector('#gift-panjiri');
    var pjMore  = root.querySelector('#gift-panjiri-more');

    var cardTo   = root.querySelector('#card-to');
    var cardFrom = root.querySelector('#card-from');
    var cardMsg  = root.querySelector('#card-msg');
    var defaultMsg = cardMsg ? cardMsg.textContent : '';

    if (maxEl) maxEl.textContent = String(MAX);
    if (msgEl) msgEl.setAttribute('maxlength', String(MAX));

    /* ── quantities ── */
    function qtyOf(row) {
      var i = row.querySelector('input');
      var n = parseInt(i.value, 10);
      if (isNaN(n) || n < 0) n = 0;
      if (n > 20) n = 20;
      i.value = String(n);
      return n;
    }

    function recalc() {
      var total = 0, any = 0;
      if (linesEl) linesEl.innerHTML = '';
      rows.forEach(function (row) {
        var q = qtyOf(row);
        var price = parseInt(row.getAttribute('data-price'), 10) || 0;
        row.classList.toggle('is-on', q > 0);
        if (q > 0) {
          any += q;
          total += q * price;
          if (linesEl) {
            var li = document.createElement('li');
            var s = document.createElement('span');
            s.textContent = q + ' × ' + row.getAttribute('data-name');
            var b = document.createElement('b');
            b.textContent = fmt(q * price, MONEY);
            li.appendChild(s); li.appendChild(b);
            linesEl.appendChild(li);
          }
        }
      });
      if (noneEl) noneEl.hidden = any > 0;
      if (totalEl) totalEl.textContent = any > 0 ? fmt(total, MONEY) : '—';
      if (addBtn) addBtn.disabled = any === 0;
    }

    rows.forEach(function (row) {
      var input = row.querySelector('input');
      row.querySelectorAll('[data-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-step'), 10);
          input.value = String(Math.max(0, Math.min(20, (parseInt(input.value, 10) || 0) + step)));
          recalc();
        });
      });
      input.addEventListener('input', recalc);
      input.addEventListener('blur', recalc);
    });
    recalc();

    /* ── panjiri ── */
    if (pjEl) {
      pjEl.addEventListener('change', function () {
        if (pjMore) pjMore.hidden = !pjEl.checked;
      });
    }

    /* ── live card ── */
    function clean(v) { return (v || '').replace(/\s+/g, ' ').trim(); }
    function paint() {
      var t = clean(toEl && toEl.value);
      var f = clean(fromEl && fromEl.value);
      var m = msgEl ? msgEl.value : '';
      if (cardTo)   { cardTo.innerHTML = 'To <b></b>';   cardTo.querySelector('b').textContent = t || 'someone special'; }
      if (cardFrom) { cardFrom.innerHTML = '— <b></b>'; cardFrom.querySelector('b').textContent = f || 'you'; }
      if (cardMsg)  { cardMsg.textContent = m.trim() ? m : defaultMsg; }
      if (countEl) {
        countEl.textContent = String(m.length);
        countEl.parentNode.classList.toggle('is-max', m.length >= MAX);
      }
    }
    [toEl, fromEl, msgEl].forEach(function (el) { if (el) el.addEventListener('input', paint); });
    paint();

    /* ── add to cart ──
       Items carry a per-line "Gift box" flag; the card itself is a cart
       attribute so one message covers the whole hamper, however many jars. */
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = [];
        rows.forEach(function (row) {
          var q = qtyOf(row);
          if (q > 0) {
            items.push({
              id: Number(row.getAttribute('data-variant')),
              quantity: q,
              properties: { 'Gift box': 'Yes — Diwali gift' }
            });
          }
        });
        if (!items.length) return;

        addBtn.disabled = true;
        var original = addBtn.textContent;
        addBtn.textContent = 'Adding…';

        var attrs = {};
        var t = clean(toEl && toEl.value);
        var f = clean(fromEl && fromEl.value);
        var m = msgEl ? msgEl.value.trim() : '';
        attrs['Gift to'] = t;
        attrs['Gift from'] = f;
        attrs['Gift message'] = m;
        attrs['Panjiri'] = (pjEl && pjEl.checked) ? 'Yes — customer wants panjiri, price to agree' : '';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          });
        }).then(function () {
          window.location.href = CODE
            ? '/discount/' + encodeURIComponent(CODE) + '?redirect=/cart'
            : '/cart';
        }).catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = original;
          if (statusEl) statusEl.textContent = 'Something went wrong adding that. Please try again, or message us.';
        });
      });
    }

    /* ── copy the coupon code ── */
    var codeBtn = document.getElementById('gift-code');
    var codeDone = document.getElementById('gift-code-done');
    if (codeBtn) {
      codeBtn.addEventListener('click', function () {
        var code = codeBtn.getAttribute('data-code') || '';
        function flash() {
          if (!codeDone) return;
          codeDone.hidden = false;
          setTimeout(function () { codeDone.hidden = true; }, 1400);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(flash, flash);
        } else {
          var t = document.createElement('textarea');
          t.value = code; t.setAttribute('readonly', '');
          t.style.position = 'absolute'; t.style.left = '-9999px';
          document.body.appendChild(t); t.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(t);
          flash();
        }
      });
    }

    /* ── fireworks ── */
    var host = document.getElementById('giftb-fw');
    var seed = document.querySelector('.giftb__card-burst--a svg');
    if (host && seed) fireworks(host, seed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();